import type { OverflowTabItem } from '@pesto/ui';

import { OverflowTabs } from '@pesto/ui';

import type { CardProfileProps } from '../types/Cards.types';

import { CardDetailsView } from './CardDetailsView';
import { CardSummary } from './CardSummary';

export const CardProfile = ({
  card,
  owner,
  loan,
  ownerDetails,
  actions,
  onOwnerClick,
  onLoanClick,
  extraTabs = [],
  currentTab,
  onTabChange,
}: CardProfileProps) => {
  const primary: OverflowTabItem[] = [
    {
      label: 'Details',
      value: 'details',
      component: (
        <CardDetailsView
          owner={owner}
          loan={loan}
          ownerDetails={ownerDetails}
          onOwnerClick={onOwnerClick}
          onLoanClick={onLoanClick}
        />
      ),
    },
    ...extraTabs,
  ];

  return (
    <div className="space-y-4">
      <CardSummary card={card} actions={actions} />
      <OverflowTabs primary={primary} value={currentTab} onValueChange={onTabChange} />
    </div>
  );
};
